import React, { useEffect } from "react";
import { Redirect } from "react-router";
import { Col, Row } from "react-bootstrap";
import TeamSearch from "../components/TeamSearch/TeamSearch";
import TeamTable from "../components/TeamTable/TeamTable";
import { useSelector, useDispatch, shallowEqual } from "react-redux";

import { fetchTeams, teamsSelector } from "../_redux/teamsSlice";
import { RootState } from "../../../../redux/rootReducer";

function TeamsListPage() {
  const dispatch = useDispatch();
  const { fetchingTeamsError } = useSelector(teamsSelector);
  const { currentPage } = useSelector(teamsSelector);
  const { user } = useSelector(
    ({ auth }: RootState) => ({
      user: auth.user,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(fetchTeams({ searchText: "", pageNumber: currentPage }));
  }, [currentPage, dispatch]);

  if (fetchingTeamsError) return <div>{fetchingTeamsError.message}</div>;

  if (!user) {
    return <Redirect to="/auth/login" />;
  }

  if ((user && !user.teams) || !user.teams.length) {
    return <Redirect to="/onboarding" />;
  }

  return (
    <>
      <Row>
        <Col sm={12}>
          <div className="mb-5">
            <TeamSearch />
          </div>
          <TeamTable />
        </Col>
      </Row>
    </>
  );
}

export default TeamsListPage;
